"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.object.freeze");

var _cssClasses = _interopRequireDefault(require("../helpers/cssClasses"));

var _utils = require("../helpers/utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/* eslint-disable */

/**
 * Mixin: Overlay
 * -----------------------------------------------------------------------------
 * A simple mixin to toggle window overlay with escape events
 *
 * @namespace Overlay
 */

/**
 * Export overlay module as default.
 */


var _default = function _default(config) {
  /**
   * Instance default settings.
   */
  var defaults = {
    namespace: 'overlay',
    container: 'window-overlay',
    appendOverlayTo: false
  };
  /**
   * Instance settings.
   */

  var settings = (0, _utils.extendDefaults)(defaults, config);
  var appendTo = settings.appendOverlayTo;
  /**
   * Construct window overlay element on DOM.
   */

  function constructOverlay() {
    var element = document.createElement('div');
    element.classList.add(settings.container);
    return element;
  }
  /**
   * Get window overlay element.
   */


  function getOverlay() {
    return document.querySelector(".".concat(settings.container));
  }
  /**
   * Open overlay and set esc events.
   */


  function open() {
    if (getOverlay()) {
      return;
    }

    render();
    setCloseEvents();
  }
  /**
   * Hide overlay and remove esc event.
   */


  function close() {
    if (!getOverlay()) {
      return;
    }

    remove();
  }
  /**
   * Render overlay after constructing DOM element.
   */


  function render() {
    var windowOverlay = constructOverlay();

    if (appendTo === false) {
      document.body.appendChild(windowOverlay);
    } else {
      var _appendTo = getAppendElement();

      _appendTo.appendChild(windowOverlay);
    } // Dirty way to avoid MutationObserver by using an instant timeout.


    window.setTimeout(function () {
      return windowOverlay.classList.add(_cssClasses["default"].active);
    }, 1);
    Frame.EventBus.emit("Overlay:".concat(settings.namespace, ":show"));
  }
  /**
   * Remove overlay from DOM after transitioning out.
   */


  function remove() {
    (0, _utils.on)('transitionend', getOverlay(), function () {
      if (getOverlay()) {
        if (appendTo === false) {
          document.body.removeChild(getOverlay());
        } else {
          var _appendTo2 = getAppendElement();

          _appendTo2.removeChild(getOverlay());
        }
      }
    });
    getOverlay().classList.remove(_cssClasses["default"].active);
  }
  /**
   * Get the element to append the overlay to.
   */


  function getAppendElement() {
    return document.querySelector(appendTo);
  }
  /**
   * Set close events.
   */


  function setCloseEvents() {
    (0, _utils.on)('click', getOverlay(), function () {
      return handleClickEvent();
    });
  }
  /**
   * Handle click event on overlay.
   */


  function handleClickEvent() {
    Frame.EventBus.emit("Overlay:".concat(settings.namespace, ":hide"));
    Frame.EventBus.emit('MenuDrawer:closeSubmenus');
  }
  /**
   * Expose public interface.
   */


  return Object.freeze({
    open: open,
    close: close
  });
};

exports["default"] = _default;